import type { Transition } from "@uirouter/core";

import { safeJsonParse } from "app/UtilitiesAndConstants/UtilityFunctions/safeJsonParse";

export const onRedirectRemoveCompareMode = (transition: Transition) => {
    const { key, pageFilter, ...rest } = transition.params() as { key: string; pageFilter: string };
    const pageFilterArray = safeJsonParse(pageFilter, []);
    if (key?.split(",").length > 1 || pageFilterArray.length > 1) {
        const updatedKey = key.split(",")[0] || "";
        const updatedPageFilter = JSON.stringify([pageFilterArray[0]]) || [];
        const changedParams = {
            key: updatedKey,
            pageFilter: updatedPageFilter,
        };
        return { params: { ...rest, ...changedParams } };
    }
};
